<template>
	<div>
		<el-dialog :title="exceltitle" :visible.sync="newExceldiag" width="1100px" :close-on-click-modal="false" append-to-body v-dialogDrag>
			<el-dialog title="选择文件" :visible.sync="daorudiag" width="600px" :close-on-click-modal="false" append-to-body v-dialogDrag>
				<!-- <minhead :headtitle="daorutitle"></minhead> -->
				<div class="Verticalcenter" style="margin-top: 82px;">
					<div class="Centerhorizontally" style="margin-left: 260px;">
						<el-input style="width: 300px;margin-right: 16px;" disabled v-model="upfilename"></el-input>

						<label style="display: flex;align-items: center;">
							<div class="Centerhorizontally bt1">选择文件</div>
							<input type="file" class="sendinput" @change="uploadFile($event)" :value="filestate" />
						</label>
					</div>
					<div slot="footer" style="justify-content: center; display: flex;margin-top: 30px;">
						<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="sureupload">确定</div>
						<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="daorudiag = false">关闭</div>
					</div>
					<!-- <div class="buttomanniu">
						<el-button type="primary" @click="sureupload">确定</el-button>
						<el-button  @click="daorudiag = false">关闭</el-button>
					</div> -->
				</div>
			</el-dialog>
			<!-- <minhead :headtitle="exceltitle"></minhead> -->
			<div class="horizontally">
				<div class="distribution-line topdao">
					<div>
						<span>模板名称</span>
						<el-input v-model="mingc" placeholder="请输入内容" style="width: 130px;margin-left: 10px;"></el-input>
					</div>
					<div>
						<span>模板用途</span>
						<el-select @change="ytSelectChanged" v-model="shitlmc" placeholder="请选择" style="width: 150px;margin-left: 10px;" :disabled="title == '编辑'">
							<el-option v-for="item in optionsyt" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
					<div>
						<span>模板模式</span>
						<el-select v-model="mos" placeholder="请选择" style="width: 130px;margin-left: 10px;" :disabled="title == '编辑'">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="sureupload" v-if="this.mos == '1'">
						<samp>
							导入
							<i class="el-icon-edit-outline el-icon--right"></i>
						</samp>
					</div>
					<!-- <el-button type="primary" @click="fordaoru" v-if="this.mos=='1'">
					导入
					<i class="el-icon-edit-outline el-icon--right"></i>
				</el-button> -->
				</div>
			</div>
			<div class="horizontally" style="margin-top: 30px;">
				<div>
					<el-table
						:cell-style="styleBack"
						border
						:data="tableDatanochoose"
						tooltip-effect="dark"
						max-height="300px"
						@row-click="radiochangenochoose"
						:row-class-name="tableRowClassName"
					>
						<el-table-column width="55" align="center">
							<template slot-scope="scope">
								<el-radio :label="scope.$index" v-model="radionochoose"></el-radio>
							</template>
						</el-table-column>
						<el-table-column prop="liejb" label="类别" width="70px">
							<template slot-scope="scope">
								<span>{{ liejbToString(scope.row.liejb) }}</span>
							</template>
						</el-table-column>

						<el-table-column prop="liezwmc" label="名称" align="center" width="280px"></el-table-column>
					</el-table>
				</div>
				<div class="Verticalcenter-inline" style="margin-left: 30px;margin-right: 30px;">
					<!-- <el-button type="primary" icon=" el-icon-d-arrow-right" plain @click="forAddToRight">添加</el-button> -->
					<div class="addstyle" style="width: 80px;" @click="forAddToRight">
						<samp>
							添加
							<i class="el-icon-d-arrow-right"></i>
						</samp>
					</div>
					<div class="dangestyle" style="width: 80px;margin-top: 10px;" @click="forAddToleft">
						<samp>
							<i class="el-icon-d-arrow-left"></i>
							移出
						</samp>
					</div>
					<!-- <el-button style="margin-top: 20px;margin-left: 0px;" plain type="danger" icon="el-icon-d-arrow-left" @click="forAddToleft">移出</el-button> -->
				</div>
				<div>
					<el-table
						:cell-style="styleBack"
						border
						:data="tableDatachoose"
						tooltip-effect="dark"
						max-height="300px"
						@row-click="radiochangechoose"
						:row-class-name="tableRowClassName"
					>
						<el-table-column width="55" align="center">
							<template slot-scope="scope">
								<el-radio :label="scope.$index" v-model="radiochoose"></el-radio>
							</template>
						</el-table-column>
						<el-table-column prop="zidm" label="Excel字段" width="150px" v-if="mos != '1'">
							<template slot-scope="scope">
								<el-input v-model="scope.row.zidm"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="zidm" label="Excel字段" width="150px" v-if="mos == '1'">
							<template slot-scope="scope">
								{{ scope.row.zidm }}
							</template>
						</el-table-column>
						<el-table-column prop="xuh" label="序号" width="70px"></el-table-column>

						<el-table-column prop="liezwmc" label="名称" width="100px"></el-table-column>

						<el-table-column prop="liejb" label="类别" width="70px">
							<template slot-scope="scope">
								<span>{{ liejbToString(scope.row.liejb) }}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div style="margin-top: 30px;padding-bottom: 28px;" class="between-line">
				<div></div>
				<div slot="footer" style="justify-content: right; display: flex;margin-top: 30px;">
					<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="forsave">保存</div>
					<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="newExceldiag = false">关闭</div>
				</div>
				<!-- <div class="rightbuttom">
					<div @click="forsave">保存</div>
					<div @click="newExceldiag = false">关闭</div>
				</div> -->
			</div>
		</el-dialog>
		<minhead :headtitle="headtitle"></minhead>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<!-- <el-button type="primary" plain style="width: 100px;" @click="addnewExcel">
						新建
						<i class="el-icon-circle-plus-outline el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 100px;margin-right: 24px;" @click="addnewExcel">
						<samp>
							新建
							<i class="el-icon-circle-plus-outline el-icon--right"></i>
						</samp>
					</div>
					<!-- <el-button type="primary" plain style="width: 100px;" @click="editnewExcel">
						编辑
						<i class="el-icon-edit-outline el-icon--right"></i>
					</el-button>
					<el-button type="primary" plain style="width: 100px;">
						删除
						<i class="el-icon-delete el-icon--right"></i>
					</el-button> -->
					<!-- <el-button type="primary" plain style="width: 100px;" @click="forrest">
						重置
						<i class="el-icon-refresh el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 100px;margin-right: 24px;" @click="forrest">
						<samp>
							重置
							<i class="el-icon-refresh el-icon--right"></i>
						</samp>
					</div>
				</div>
				<div class="Centerupdown">
					<el-input
						style="width: 250px;margin-left: 20px;margin-right: 16px;"
						placeholder="模板名称"
						prefix-icon="el-icon-search"
						clearable
						@input="forserch"
						v-model="serchval"
					></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table ref="multipleTable" :data="tableData" border style="width: 100%" height="calc(100vh - 262px )">
						<!-- <el-table-column type="selection" width="55"></el-table-column> -->
						<el-table-column label="模板模式" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<span :style="scope.row.mos == 1 ? 'font-size: 14px;color: #FF8800;margin-right:8px' : 'font-size: 14px;color: #0080FF;margin-right:8px'">
										{{ mostostring(scope.row.mos) }}
									</span>
									<img src="../../../assets/img/chu.png" width="16px" height="16px" v-if="scope.row.mos == 1" />
									<img src="../../../assets/img/ru.png" width="16px" height="16px" v-if="scope.row.mos == 2" />
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="shitlmc" label="模板用途" align="center">
							<template slot-scope="scope">
								<span>{{ shitlmctostring(scope.row.shitlmc) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="mingc" label="模板名称" align="center"></el-table-column>
						<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
						<el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
						<el-table-column fixed="right" label="操作" width="150" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="forupdate(scope.row, '编辑')">编辑</el-button>
								<el-button type="text" size="small" @click="fordelete(scope.row, '删除')" style="color: red;">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			/* 开具弹框 */
			newExceldiag: false,

			page: 1,
			pagenum: 10,
			totalcount: 0,
			tableData: [],
			tableDatanochoose: [],
			tableDatachoose: [],
			exceltitle: '新建Excel模板',
			headtitle: ['系统设置', 'Excel模板配置'],
			serchval: '',
			daorudiag: false,
			daorutitle: ['选择文件'],
			mos: '1',
			mingc: '',
			shitlmc: 'Dj',
			optionsyt: [
				{
					value: 'Dj',
					label: '单据及单据明细'
				},
				{
					value: 'Doc',
					label: '发票及发票明细'
				}
			],
			options: [
				{
					value: '1',
					label: '导入'
				}
				// {
				// 	value: '2',
				// 	label: '导出'
				// }
			],
			upfilename: '',
			upfile: '', //上传文件,
			/* 左侧选择数据 */
			Changenochooseval: {},
			Changenochoosevalindex: '',
			Changechoosevalindex: null,
			radionochoose: 0,
			radiochoose: 0,
			filestate: '',
			title: '',
			qiybh: '',
			version: '',
			tableHeight: ''
		};
	},
	created() {
		this.getTemplateList();
	},
	mounted() {
		this.$nextTick(() => {
			this.tableHeight = this.diagheight();
			this.$refs.multipleTable.doLayout();
			window.onresize = () => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
			};
		});
	},
	methods: {
		styleBack({ row, column, rowIndex, columnIndex }) {
			if (
				row.liezwmc == '单据号' ||
				row.liezwmc == '发票类型代码' ||
				row.liezwmc == '明细单价' ||
				row.liezwmc == '明细商品数量' ||
				row.liezwmc == '明细金额' ||
				row.liezwmc == '明细商品名称' ||
				row.liezwmc == '明细税收编码' ||
				row.liezwmc == '明细税率' ||
				row.liezwmc == '明细是否含税'
			) {
				return { color: '#f80327' };
			}
		},
		// 用途选择按钮
		ytSelectChanged(val) {
			// 同步切换 模板模式
			// 重新加载 对应的 列
			// 导入按钮的显示
			// 清空 选中的数据
			if (val == 'Dj') {
				this.mos = '1';
				this.getColumnNames();
				this.options = [
					{
						value: '1',
						label: '导入'
					}
				];
				this.tableDatachoose = [];
			} else if (val == 'Doc') {
				this.mos = '2';
				this.getColumnNames();
				this.options = [
					{
						value: '2',
						label: '导出'
					}
				];
				this.tableDatachoose = [];
			}
		},
		liejbToString(value) {
			let valueFormat;
			if (value == '1') {
				valueFormat = '表头';
			} else if (value == '2') {
				valueFormat = '明细';
			}
			return valueFormat;
		},
		forrest() {
			this.release();
			this.page = 1;
			(this.pagenum = 10), (this.serchval = '');
			this.getTemplateList();
		},
		tableRowClassName({ row, rowIndex }) {
			//把每一行的索引放进row
			row.index = rowIndex;
		},

		/* 选择左侧数据 */
		radiochangenochoose(row, event, column) {
			this.Changenochooseval = row;
			this.Changenochoosevalindex = row.index;
			this.radionochoose = row.index;
		},
		forupdate(row, title) {
			this.exceltitle = '编辑Excel模板';
			this.title = title;
			this.getUploadTemplateDetail(row);
		},

		fordelete(row) {
			this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deleteUploadTemplate(row.id);
			});
		},
		forserch() {
			this.getTemplateList();
		},
		radiochangechoose(row, event, column) {
			console.log(row);
			this.Changechoosevalindex = row.index;
			this.radiochoose = row.index;
		},

		forAddToRight() {
			let newitem = {};
			if (this.mos == '1' && this.shitlmc == 'Dj') {
				if (JSON.stringify(this.Changenochooseval) == '{}' || this.Changechoosevalindex == null) {
					this.$message.error('请选择添加数据');
					return false;
				}
				newitem = {
					liejb: this.Changenochooseval.liejb,
					liem: this.Changenochooseval.liem,
					liezwmc: this.Changenochooseval.liezwmc,
					xuh: this.tableDatachoose[this.Changechoosevalindex].xuh,
					zidm: this.tableDatachoose[this.Changechoosevalindex].zidm
				};

				if (this.notemptyandnull(this.tableDatachoose[this.Changechoosevalindex].liejb)) {
					console.log(this.tableDatanochoose);
					this.tableDatanochoose.push({
						liejb: this.tableDatachoose[this.Changechoosevalindex].liejb,
						liem: this.tableDatachoose[this.Changechoosevalindex].liem,
						liezwmc: this.tableDatachoose[this.Changechoosevalindex].liezwmc
					});
				}

				this.$set(this.tableDatachoose, this.Changechoosevalindex, newitem);

				this.tableDatanochoose.splice(this.Changenochoosevalindex, 1);
				this.radiochoose = '';
				this.radionochoose = '';
				this.Changenochooseval = {};
				this.Changenochoosevalindex = '';
				this.Changechoosevalindex = null;
			} else if (this.mos == '2' && this.shitlmc == 'Doc') {
				if (JSON.stringify(this.Changenochooseval) == '{}') {
					this.$message.error('请选择添加数据');
					return false;
				}
				// 序号 计算数组的长度
				newitem = {
					liejb: this.Changenochooseval.liejb,
					liem: this.Changenochooseval.liem,
					liezwmc: this.Changenochooseval.liezwmc,
					xuh: this.tableDatachoose.length,
					zidm: this.Changenochooseval.liezwmc
				};

				this.tableDatachoose.push(newitem);

				this.tableDatanochoose.splice(this.Changenochoosevalindex, 1);
				this.radiochoose = '';
				this.radionochoose = '';
				this.Changenochooseval = {};
				this.Changenochoosevalindex = '';
				this.Changechoosevalindex = null;
			}
		},

		release() {
			this.upfilename = '';
			this.upfile = '';
			this.Changenochooseval = {};
			this.tableDatachoose = [];
			this.Changenochoosevalindex = '';
			this.Changechoosevalindex = null;
			this.mingc = '';
			this.filestate = null;
			this.radionochoose = '';
			this.radiochoose = '';
		},
		forAddToleft() {
			if (this.mos == '1' && this.shitlmc == 'Dj') {
				if (this.tableDatachoose[this.Changechoosevalindex].liejb == null) {
					this.$message.error('没有可移除数据');
					return false;
				}
				let newitem = {
					xuh: this.tableDatachoose[this.Changechoosevalindex].xuh,
					zidm: this.tableDatachoose[this.Changechoosevalindex].zidm
				};

				this.tableDatanochoose.push({
					liejb: this.tableDatachoose[this.Changechoosevalindex].liejb,
					liem: this.tableDatachoose[this.Changechoosevalindex].liem,
					liezwmc: this.tableDatachoose[this.Changechoosevalindex].liezwmc
				});
				this.$set(this.tableDatachoose, this.Changechoosevalindex, newitem);

				this.radiochoose = '';
				this.radionochoose = '';
			} else if (this.mos == '2' && this.shitlmc == 'Doc') {
				if (this.tableDatachoose[this.Changechoosevalindex].liejb == null) {
					this.$message.error('没有可移除数据');
					return false;
				}
				// 删除的添加到左侧
				this.tableDatanochoose.push({
					liejb: this.tableDatachoose[this.Changechoosevalindex].liejb,
					liem: this.tableDatachoose[this.Changechoosevalindex].liem,
					liezwmc: this.tableDatachoose[this.Changechoosevalindex].liezwmc
				});
				// 从删除的位置  更新后面的序号
				//console.log(this.radiochoose);
				this.tableDatachoose.splice(this.Changechoosevalindex, 1);

				// 从移除的位置 开始 更新数组的序号
				this.tableDatachoose.forEach((item, index) => {
					//console.log(item.xuh +"..."+index)
					item.xuh = index;
				});
			}
		},
		forsave() {
			if (this.title == '新建') {
				this.insertUploadTemplate('0', this.mos, this.shitlmc, this.mingc);
			}
			if (this.title == '编辑') {
				this.updateUploadTemplate('0', this.mos, this.shitlmc, this.mingc, this.qiybh, this.version, this.id);
			}
		},
		fordaoru() {
			this.daorudiag = true;
		},
		addnewExcel() {
			this.title = '新建';
			this.shitlmc = 'Dj';
			this.mos = '1';
			this.options = [
				{
					value: '1',
					label: '导入'
				}
			];
			this.getColumnNames();
		},

		uploadFile($event) {
			this.upfilename = $event.target.files[0].name;
			var reader = new FileReader();
			let fileData = $event.target.files[0];
			let formData = new FormData();
			formData.append('uploadFile', fileData);
			this.upfile = formData;
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.getTemplateList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getTemplateList();
		},

		/* 选择右侧数据 */
		sureupload() {
			this.uploadTemplateExcel(this.upfile);
		},
		/* 接口调用操作 */
		deleteUploadTemplate(id) {
			let params = id;
			this.$https.fetchPost('/template/deleteUploadTemplate', params).then(res => {
				if (res.data.success) {
					this.$message.success('删除成功');
					this.getTemplateList();
				}
			});
		},
		/* 	获取编辑数据 */
		getUploadTemplateDetail(row) {
			let params = {
				templateId: row.id,
				entityName: row.shitlmc
			};
			this.$https.fetchPost('/template/getUploadTemplateDetail', params).then(res => {
				if (res.data.success) {
					this.release();
					this.mos = row.mos;
					this.mingc = row.mingc;
					this.qiybh = row.qiybh;
					this.version = row.version;
					this.shitlmc = row.shitlmc;
					this.id = row.id;
					this.tableDatanochoose = res.data.obj.columns;
					this.tableDatachoose = res.data.obj.templateDetail;
					this.newExceldiag = true;
				}
			});
		},
		getTemplateList() {
			let params = {
				page: this.page,
				limit: this.pagenum,
				pagenum: this.pagenum,
				likeSearch: this.serchval
			};

			this.$https.fetchPost('/template/getTemplateList', params).then(res => {
				this.tableData = res.data.data;
				this.totalcount = res.data.count;
			});
		},
		/* 模板配置，获取可配置字段 */

		getColumnNames() {
			let params = '';
			if (this.mos == '1') {
				params = 'Dj';
			} else if (this.mos == '2') {
				params = 'Doc';
			}
			this.$https.fetchPost('/template/getColumnNames', params).then(res => {
				this.tableDatanochoose = res.data.obj;
				this.release();
				this.newExceldiag = true;
			});
		},
		uploadTemplateExcel(file) {
			let params = file;
			this.$https.fetchPost('/template/uploadTemplateExcel', params).then(res => {
				if (res.data.success) {
					this.tableDatachoose = res.data.obj;
					this.daorudiag = false;
					let params = '';
					if (this.mos == '1') {
						params = 'Dj';
					} else if (this.mos == '2') {
						params = 'Doc';
					}
					this.$https.fetchPost('/template/getColumnNames', params).then(res => {
						this.tableDatanochoose = res.data.obj;
						this.newExceldiag = true;
					});
				}
			});
		},
		updateUploadTemplate(leix, mos, shitlmc, mingc, qiybh, version, id) {
			let stringparams = {
				leix: leix,
				mos: mos,
				shitlmc: shitlmc,
				mingc: mingc,
				qiybh: qiybh,
				version: version,
				id: id
			};
			let params = {
				templateData: JSON.stringify(stringparams),
				fieldData: JSON.stringify(this.tableDatachoose)
			};
			this.$https.fetchPost('/template/updateUploadTemplate', params).then(res => {
				console.log(res.data.success);
				if (res.data.success) {
					this.newExceldiag = false;
					this.$message.success('配置修改成功');
					this.getTemplateList();
				}
			});
		},
		insertUploadTemplate(leix, mos, shitlmc, mingc) {
			if (this.tableDatachoose == null || this.tableDatachoose.length == 0) {
				this.$message.error('请配置模板内容选项');
				return;
			}
			let stringparams = {
				leix: leix,
				mos: mos,
				shitlmc: shitlmc,
				mingc: mingc
			};
			let params = {
				templateData: JSON.stringify(stringparams),
				fieldData: JSON.stringify(this.tableDatachoose)
			};
			this.$https.fetchPost('/template/insertUploadTemplate', params).then(res => {
				console.log(res.data.success);
				if (res.data.success) {
					this.newExceldiag = false;
					this.$message.success('配置保存成功');
					this.getTemplateList();
				}
			});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/.el-radio__label {
	display: none;
}
.sendinput {
	visibility: hidden;
}
.bt1 {
	width: 80px;
	height: 31px;
	border: 1px solid #e5e5e5;
	border-radius: 3px;
	font-size: 14px;
	cursor: pointer;
	font-weight: 500;
	color: #2f66fc;
}
.topdao {
	width: 1000px;
	font-size: 18px;
	font-weight: 400;
	color: #0080ff;
	margin-right: 10px;
}
// /deep/.el-dialog__body {
// 	padding: 0;
// }
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}

.areatable {
	margin-top: 27px;
}
.areacontent {
	margin-left: 21px;
}
</style>
